<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="form-elements-sec">
                        <div class="widget-title">
                            <h3>Blog Ekle</h3>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="category">Kategori</label>
                                    <select class="form-control custom-input" v-model="category">
                                        <option value="" selected disabled hidden>Seçiniz...</option>
                                        <option
                                                v-for="category in categories"
                                                :key="category.id"
                                                :value="category.id"
                                        >{{ category.title }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="cover">Kapak Resmi</label>
                                    <input type="file" @change="onCover" class="form-control custom-input">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="title">Blog Başlığı</label>
                                    <input type="text" v-model="title" class="form-control custom-input">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="slug">SEF Link</label>
                                    <input type="text" v-model="slug" class="form-control custom-input">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="meta_keywords">Meta Keywords</label>
                                    <textarea v-model="meta_keywords" class="form-control custom-input"
                                              rows="7"></textarea>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="meta_description">Meta Description</label>
                                    <textarea v-model="meta_description" class="form-control custom-input"
                                              rows="7"></textarea>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="content">İçerik</label>
                                    <vue-editor v-model="content" class="editor"></vue-editor>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="images">Resim Galerisi
                                        <small>(Birden fazla seçim yapılabilir.)</small>
                                    </label>
                                    <input type="file" class="form-control custom-input" @change="gallery" multiple>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="is_constant">Ana Sayfada Gösterilsin mi?</label>
                                    <select class="form-control custom-input" v-model="is_constant">
                                        <option value="1">Evet</option>
                                        <option value="0">Hayır</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="form-elements-sec">
                        <error :errors="validationErrors" v-if="validationErrors"></error>
                        <div style="width: 100%;" class="text-center">
                            <button class="btn btn-edit" @click="addData">Kaydet</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {VueEditor} from "vue2-editor";
    import Error from "@/components/layouts/Error";

    export default {
        components: {VueEditor, Error},

        data() {
            return {
                customToolbar: [
                    ['bold', 'italic', 'underline'],
                    [{'list': 'ordered'}, {'list': 'bullet'}]
                ],
                cover: '',
                title: "",
                category: '',
                categories: [],
                content: '',
                meta_keywords: '',
                meta_description: '',
                is_constant: '',
                images: [],
                api: "blogs",
                validationErrors: '',
            };
        },
        mounted() {
            this.getData()
        },
        methods: {
            gallery(e) {
                let selectedFlies = e.target.files;
                if (!selectedFlies.length) {
                    return false
                }
                for (let i = 0; i < selectedFlies.length; i++) {
                    this.images.push(selectedFlies[i]);
                }
                // console.log(this.images)
            },
            onCover(event) {
                this.cover = event.target.files[0]
                // console.log(this.cover)
            },
            getData() {
                this.$Progress.start();
                this.axios.get(this.api + '/create').then(response => {
                    this.categories = response.data
                    this.$Progress.finish()
                });
            },
            addData() {
                var data = {
                    category: this.category || '',
                    title: this.title || '',
                    slug: this.slug || '',
                    content: this.content || '',
                    meta_keywords: this.meta_keywords || '',
                    meta_description: this.meta_description || '',
                    is_constant: this.is_constant || '',
                }
                const formData = new FormData();
                formData.append('cover', this.cover)
                for (let i = 0; i < this.images.length; i++) {
                    formData.append('images[]', this.images[i])
                }
                Object.keys(data).map(e => {
                    formData.append(e, data[e])
                })
                this.$Progress.start();
                this.axios
                    .post(this.api, formData)
                    .then(response => {
                        if (response.status == 201) {
                            this.$router.push({
                                name: "blogs.update",
                                params: {id: response.data.id}
                            });
                        }
                    }).catch(error => {
                    this.$Progress.finish();
                    if (error.response.status == 422) {
                        this.validationErrors = error.response.data.errors;
                    } else if (error.response.status == 500) {
                        this.validationErrors = {message: ['Bilinmeyen bir hata oluştu. Lütfen servis sağlayıcınıza başvurun veya daha sonra tekrar deneyiniz.!']};
                    }
                });
            }
        },
        computed: {
            slug() {
                let slug = window.Slug(this.title)
                return slug
            }
        }
    };
</script>

<style scoped>
</style>
